import { render, staticRenderFns } from "./Rics.vue?vue&type=template&id=0f1bd1d2"
import script from "./Rics.vue?vue&type=script&lang=js"
export * from "./Rics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports